import React from 'react';
import { ModuleProps } from "components/props/ModuleProps";
import { ModuleError } from "./ModuleError";
import { ModuleLoader } from "./ModuleLoader";
import { SuspenseWithErrorBoundry } from "components/layout/suspense/SuspenseWithErrorBoundry";

interface ModuleWithDataProps {
    children: any
    dataPromise: Promise<any>;
    module: ModuleProps;
    errorText: string;
}

export const ModuleWithData = ({
    children,
    dataPromise,
    module,
    errorText
}: ModuleWithDataProps) => {
    return (
        <SuspenseWithErrorBoundry
            suspenseFallback={<ModuleLoader module={module} />}
            errorBoundryFallback={<ModuleError module={module} text={errorText} />}>
            {
                dataPromise && children
            }
        </SuspenseWithErrorBoundry>
    );
}
